// src/components/CustomStepper.jsx
import React from "react";
import {
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  stepConnectorClasses,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { styled } from "@mui/material/styles";

const steps = ["Stammdaten", "Standorte", "Maschinen", "User"];

// --- custom connector ---
const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 16,
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#e0e0e0",
    borderTopWidth: 2,
    borderRadius: 1,
  },
}));

// --- custom step icon ---
function CustomStepIcon(props) {
  const { active, completed, icon } = props;

  return (
    <div
      style={{
        width: 40,
        height: 40,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 500,
        backgroundColor: completed || active ? "var(--color-primary)" : "#fff",
        color: completed || active ? "#fff" : "grey",
        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.14),0px 2px 1px -1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)"
      }}
    >
      {completed ? <CheckIcon fontSize="small" /> : icon}
    </div>
  );
}

export default function CustomStepsHeader({ activeStep,handleStepClick }) {
  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      connector={<CustomConnector />}
    >
      {steps.map((label, index) => (
        <Step key={label} onClick={handleStepClick} sx={{ cursor: "pointer"}}>
          <StepLabel
            StepIconComponent={CustomStepIcon}
            sx={{
              "& .MuiStepLabel-label": {
                color: activeStep === index ? "#000" : "#888",
                fontWeight: activeStep === index ? 600 : 400,
              },
            }}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}
